'use client'

import Link from 'next/link'
import { useEffect } from 'react'
import ErrorCode from './components/svg/ErrorCode'

 
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {

    console.error('GLOBAL ERROR:', error);
  console.error('DIGEST:', error.digest);
  useEffect(() => {
    console.error('global error', error);
  }, [error]);
  return (
    <html lang='ar' dir='rtl' className='h-full w-full'>
      <body className='h-full w-full'>
    <div className='h-full w-full grid place-items-center px-[24px] desktop:px-0'>
         <div className="h-full flex flex-col justfy-center items-center gap-y-[24px] w-full max-w-[1296px] pt-[48px] text-center">
           <ErrorCode/>
         <span className="h1 text-black dark:text-white">الموقع قيد الصيانة حالياً.</span>
         <span className='h3 text-black dark:text-white'>نعمل على تحسين تجربتك وسنعود قريباً.</span>
         <a href='/' title='الصفحة الرئيسية' className='self-center grid place-items-center h-[62px] w-fit md bg-primary text-white p-[16px] px-[24px] rounded-[4px] mb-[24px]'>العودة إلى الصفحة الرئيسية</a>
       </div>
       </div>
      </body>
    </html>
  )
}